// ============================================
// 📝 INFORMATIONS PERSONNELLES
// Modifie ce fichier pour personnaliser ton portfolio
// ============================================

// ============================================
// 🎂 CALCUL AUTOMATIQUE DE L'ÂGE
// ============================================

const birthDate = new Date('2002-01-25'); // Format ISO obligatoire

function calculateAge(date) {
    const today = new Date();
    let age = today.getFullYear() - date.getFullYear();
    const monthDiff = today.getMonth() - date.getMonth();

    if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < date.getDate())
    ) {
        age--;
    }

    return age;
}
export const personalInfo = {
    name: 'Clément Auger',
    initials: 'CA',
    role: 'Développeur Informatique',
    age: calculateAge(birthDate),
    email: 'clemauger01@orange.fr',
    phone: '06 61 20 63 37',
    location: 'Saint-Pierre-du-Regard (61)',
    postalCode: '61790',

    // Liens sociaux
    social: {
        github: 'https://github.com/Cauger14',
        linkedin: 'https://linkedin.com/in/clement-auger',
        portfolio: 'https://clement-auger.com',
    },

    // Permis et mobilité
    license: 'B + véhicule personnel',
    englishLevel: 'Opérationnel',

    // Statistiques affichées sur la page d'accueil
    stats: {
        yearsExperience: '2+',
        languages: '6+',
    },

    // Description courte pour la page d'accueil
    shortBio: `Passionné par l'univers du numérique, je crée des applications web modernes et performantes. 
Nouvellement diplômé en développement informatique, je suis à la recherche d'une opportunité en alternance pour un Bac+3 Concepteur Développeur d'Applications.`,

    // Description pour la page À Propos
    aboutBio: `Animé par l'univers du numérique, je souhaite améliorer mes connaissances 
dans le développement informatique à travers l'alternance, tout en contribuant 
au succès de l'entreprise.`,
};

// ============================================
// 💼 EXPÉRIENCES PROFESSIONNELLES
// ============================================

export const experiences = [
    {
        title: 'Alternant Développeur Web',
        company: 'Agence Web WSF',
        location: 'Vire',
        period: 'Sept. 2024 - Août 2025',
        tasks: [
            'Utilisation du CMS Joomla',
            'Création et refonte de sites web',
            'Optimisation interface UX/UI',
            'Gestion des DNS et noms de domaines',
            'Déploiement sur serveur distant',
            'Gestion des tickets et suivi client',
        ],
    },
    {
        title: 'Stagiaire Développeur Web',
        company: 'Agence Web WSF',
        location: 'Vire',
        period: 'Mars 2024 - Août 2024',
        tasks: [
            'Utilisation du CMS Joomla',
            'Création et refonte de sites web',
            'Gestion des DNS et noms de domaines',
        ],
    },
    {
        title: 'Opérateur de Production',
        company: 'Inteva Products',
        location: 'Esson',
        period: 'Nov. 2020 - Juil. 2022',
        tasks: ['Opérateur de ligne', 'Manutention', 'Opérateur de qualité'],
    },
];

// ============================================
// 🎓 FORMATIONS
// ============================================

export const education = [
    {
        degree: 'Bac+2 Développeur Informatique',
        school: "CESI École d'Ingénieurs",
        location: 'Hérouville',
        period: '2023 - 2025',
    },
    {
        degree: 'Bac Pro Maintenance Véhicule',
        school: 'Lycée Jules Verne',
        location: 'Mondeville',
        period: '2017 - 2020',
    },
];

// ============================================
// 🧠 SOFT SKILLS
// ============================================

export const softSkills = [
    'Curiosité',
    'Proactivité',
    'Assertivité',
    'Adaptabilité',
];

// ============================================
// ❤️ CENTRES D'INTÉRÊT
// ============================================

export const interests = [
    {
        title: 'Engagement Associatif',
        description: 'Unicorn 2 - Organisation et accueil',
    },
    {
        title: 'Maintenance Véhicule',
        description: 'Entretien mécanique familial',
    },
];
